import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=2ef7949e&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=2ef7949e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef7949e",
  null
  
)

export default component.exports